import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useRef, useCallback, useMemo, useState } from 'react';
const MapContext = createContext(null);
export const MapProvider = ({ children }) => {
    const mapRef = useRef(null);
    const extraLayersRef = useRef(null);
    // State to trigger re-renders when map is set
    const [isMapReady, setIsMapReady] = useState(false);
    const getMap = useCallback(() => mapRef.current, []);
    const getExtraLayers = useCallback(() => extraLayersRef.current, []);
    const setMap = useCallback((map) => {
        mapRef.current = map;
        setIsMapReady(!!map);
    }, []);
    const setExtraLayers = useCallback((layers) => {
        extraLayersRef.current = layers;
    }, []);
    const value = useMemo(() => ({
        getMap,
        getExtraLayers,
        setMap,
        setExtraLayers,
        isMapReady,
    }), [getMap, getExtraLayers, setMap, setExtraLayers, isMapReady]);
    return _jsx(MapContext.Provider, { value: value, children: children });
};
export const useMap = () => {
    const context = useContext(MapContext);
    if (!context) {
        throw new Error('useMap must be used within MapProvider');
    }
    return context;
};
